import { useMemo, useState } from 'react';
import { Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import FurtitureFixtures from './FurnitureFixtures';

const MainCategory = ({ setFormData, formData, setContentModal }) => {
  const [category, setCategory] = useState('');
  const { new_tree } = useSelector(state => state.appsetting);

  const mainCategories = useMemo(() => {
    const news = new_tree?.sub_categories?.find(el =>
      el.name.toLowerCase().includes('news')
    );

    const rest = new_tree?.sub_categories
      ?.find(el => el.name.toLowerCase().includes('shop'))
      .sub_categories.filter(
        el =>
          el.name.toLowerCase().includes('portfolio') ||
          el.name.toLowerCase().includes('fixtures')
      );

    const result = rest.concat(news).map(el => {
      return {
        id: el._id,
        name: el.name
      };
    });

    return result;
  }, [new_tree]);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  useState(() => {
    setFormData({
      category01ISbb_q4sg_content_categoriesID: '',
      category03ISbb_q4sg_content_categoriesID: '',
      category: ''
    });
  }, [formData]);

  return (
    <>
      <Row>
        <fieldset className={'form-legend-item-wrapper mb-4'}>
          <legend className="item-title fs-1 fw-semi-bold">
            Choose option
          </legend>
          <Form.Control
            as="select"
            required
            className="form-select"
            value={formData.category}
            name="category"
            onChange={e => {
              handleChange(e);

              const selectedOption = e.target.selectedOptions[0];
              const name = selectedOption.getAttribute('data-name');

              setContentModal(name);
              setCategory(name);
            }}
          >
            <option value="" disabled>
              Choose category
            </option>
            {mainCategories?.map((status, index) => (
              <option value={status.id} data-name={status.name} key={index}>
                {status.name}
              </option>
            ))}
          </Form.Control>
        </fieldset>
      </Row>
      {category === 'Fixtures & Furniture' && (
        <FurtitureFixtures form={formData} setFormData={setFormData} />
      )}
    </>
  );
};

export default MainCategory;
